import { MAX_UPLOAD_BYTES, MAX_UPLOAD_MB, MAX_UPLOAD_SIZE_TEXT } from '../../../../constants'

/** Copy shared by the desktop upload modal, the mobile upload page, and the toasts. */
export const UPLOAD_COPY = {
  intro: 'Upload a statement and AI will read it and automatically fill in your investments.',
  disclaimer:
    'Uploading documents is optional. If you choose to upload a document, please review and confirm all extracted information before continuing.',
  disclaimerLink: 'AI Disclaimer',
  dropZone: 'Drag & drop it here, or pick from your files',
  requirementsTitle: 'Upload Requirements',
  requirements: [
    'Must be a PDF file',
    MAX_UPLOAD_SIZE_TEXT,
    'Should contain information about the investments that you have in this account– look for tickers and balances',
  ],
  fileRequirementsTitle: 'File Requirements',
  fileRequirements: ['Must be a PDF file', MAX_UPLOAD_SIZE_TEXT],
  findStatementTitle: 'How to Find Your Statement',
  findStatementSteps: [
    'Log in to your account.',
    'Go to “Documents,” “Statements,” or “Reports” in the main menu.',
    'Select “Account Statements” or “Monthly Statements.”',
    'Choose the latest month and download the PDF to your device.',
  ],
  processingHeading: 'Uploading statement…',
  processingLead: 'We’ll let you know when we’re done processing your document.',
  processingNote:
    'It’ll probably take less than a minute– feel free to leave this screen if you’d like.',
  cardProcessing: 'We’re processing your document– should take less than a minute.',
  successHeading: 'Upload complete!',
  successBody: 'Your investments are ready for review.',
  errorHeading: 'We couldn’t find anything helpful.',
  errorBody:
    'This could be because the document is corrupted/blurry or it doesn’t have investment balance info.',
  backendErrorHeading: 'Sorry! Something went wrong.',
  backendErrorBody: 'Our tech team is on it. Try again later.',
  reviewNote:
    'Note: AI can make mistakes. Please review and confirm all extracted information before continuing.',
  singleFile: 'You can only upload one file at a time',
  wrongType: 'File type is invalid — the statement must be a PDF.',
  tooLarge: `File is larger than ${MAX_UPLOAD_MB} MB.`,
}

/** Re-exported so callers of this module get the guard and its copy from one place. */
export { MAX_UPLOAD_BYTES }

/**
 * @param {File[]} files
 * @returns {string|null} An error message, or null when the selection is usable.
 */
export const validateStatementFiles = files => {
  if (!files || files.length === 0) return null
  if (files.length > 1) return UPLOAD_COPY.singleFile

  const [file] = files

  if (file.type !== 'application/pdf' && !/\.pdf$/i.test(file.name)) return UPLOAD_COPY.wrongType
  if (file.size > MAX_UPLOAD_BYTES) return UPLOAD_COPY.tooLarge

  return null
}
